export default __webpack_public_path__ + "static/media/hoofdschakelaar_preview.50305d62.jpg";